const getBrowserLocale = (): string => {
  if (typeof window === "undefined") return "de-DE"
  return navigator.language || "de-DE"
}

export function getFormattedNumber(
  value: number | string | null | undefined,
  options?: Intl.NumberFormatOptions
): string {
  if (value === null || value === undefined) return ""

  let numValue: number

  if (typeof value === "string") {
    const cleaned = value.replace(/\./g, "").replace(/,/g, ".")
    numValue = parseFloat(cleaned)
  } else {
    numValue = value
  }

  if (isNaN(numValue)) return ""

  return new Intl.NumberFormat(getBrowserLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(numValue)
}

export function getCurrencySymbol(currency: string = "EUR"): string {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: currency,
  })
  const parts = formatter.formatToParts(1)
  const symbolPart = parts.find((part) => part.type === "currency")
  return symbolPart ? symbolPart.value : currency
}

export function formatThousandsSeparator(input: string): string {
  const parts = input.split(",")
  const integerPart = parts[0].replace(/\D/g, "")
  const decimalPart = parts[1] || ""

  const formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".")

  return decimalPart ? `${formatted},${decimalPart}` : formatted
}

export function parseUserInput(cleanedInput: string): number | undefined {
  if (!cleanedInput.includes(",")) {
    if (cleanedInput === "") {
      return undefined
    }
    return parseInt(cleanedInput, 10)
  } else {
    const parts = cleanedInput.split(",")
    const integerPart = parts[0] || "0"
    let decimalPart = parts[1] || ""

    if (decimalPart.length > 2) {
      decimalPart = decimalPart.substring(0, 2)
    }

    if (integerPart === "" && decimalPart === "") {
      return undefined
    }

    const intValue = integerPart === "" ? 0 : parseInt(integerPart, 10)
    const decValue =
      decimalPart === "" ? 0 : parseInt(decimalPart.padEnd(2, "0"), 10)

    return intValue + decValue / 100
  }
}

export function getFormattedCurrency(
  value: number | string | null | undefined,
  currency: string = "EUR"
): string {
  if (value === null || value === undefined) return ""

  let numValue: number

  if (typeof value === "string") {
    const cleaned = value.replace(/\./g, "").replace(/,/g, ".")
    numValue = parseFloat(cleaned)
  } else {
    numValue = value
  }

  if (isNaN(numValue)) return ""

  return new Intl.NumberFormat(getBrowserLocale(), {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numValue)
}
